import { render, staticRenderFns } from "./CommercialInfoStep.vue?vue&type=template&id=639ef693&lang=pug&"
import script from "./CommercialInfoStep.vue?vue&type=script&lang=js&"
export * from "./CommercialInfoStep.vue?vue&type=script&lang=js&"
import style0 from "./CommercialInfoStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommercialInfoStep.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
})
